import { env } from "configs/EnvironmentConfig";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const API_ERROR = "LOGIN_API_ERROR";
export const AUTH_TOKEN = "authUser-" + env.APP_CODE;
export const FORCE_CHANGE_PASS = "forceChangePass-" + env.APP_CODE;

export const SOCIAL_LOGIN = "SOCIAL_LOGIN";
export const USER_INFO = "userInfo";

export const GEN_JWT_FROM_AZURE = "GEN_JWT_FROM_AZURE";
export const GEN_JWT_FROM_AZURE_SUCCESS = "GEN_JWT_FROM_AZURE_SUCCESS";
export const GEN_JWT_FROM_AZURE_FAIL = "GEN_JWT_FROM_AZURE_FAIL";
export const IS_AZURE = "isAzure";
